import { render, staticRenderFns } from "./online-pk-record.vue?vue&type=template&id=1fa20912&scoped=true&"
import script from "./online-pk-record.vue?vue&type=script&lang=js&"
export * from "./online-pk-record.vue?vue&type=script&lang=js&"
import style0 from "./online-pk-record.vue?vue&type=style&index=0&id=1fa20912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa20912",
  null
  
)

export default component.exports